// extracted by mini-css-extract-plugin
export default {"container":"ButtonsPolls_container__49Wrf","buttonPolls":"ButtonsPolls_buttonPolls__zNA0C"};